module.exports = __webpack_public_path__ + "static/img/05.3fff615.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/05.jpg
// module id = jVAc
// module chunks = 0